import { mat4, vec3 } from 'gl-matrix';
import { Image3D } from './image3d';

/**
 * Computes the initial rigid registration transform that aligns
 * the geometric centers of two images.
 */
export function computeCenterAlignmentTransform(
    primaryImage: Image3D,
    secondaryImage: Image3D
): mat4 {
    const translation = vec3.subtract(
        vec3.create(),
        primaryImage.grid.center,
        secondaryImage.grid.center
    );
    return mat4.fromTranslation(mat4.create(), translation);
}
